import React, { useState, useEffect } from "react";

import { useHistory } from "react-router-dom";

// Components imports
import InputField from "../../components/common/InputField";
import Button from "../../components/common/Button";
import NavigationBar from "../../components/common/NavigationBar";
import SelectElement from "../../components/common/SelectElement";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
  getCurrentUserData,
  updateCurrentUserData,
  manuallyTrigerSuccess,
  updateCurrentUserPassword
} from "../../redux/actions/currentUserActions";

import { updateCertainArchive } from "../../redux/actions/archiveActions";

import { logout } from "../../redux/actions/loginAction";

// Scss imports
import css from "./EditArchive.module.scss";

interface EditArchiveProps {
  text?: string;
}

const EditArchive: React.FC<EditArchiveProps> = ({}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const certainArchiveData = useSelector(
    (state: any) => state.archive.certainArchive
  );

  // Curent user data
  const currentUserData = useSelector(
    (state: any) => state.currentUser.currentUserData
  );

  // Updation fields status
  const updateCurrentUserDataStatus = useSelector(
    (state: any) => state.currentUser.updateCurrentUserDataStatus
  );

  // Updating fields error
  const updateCurrentUserDataError = useSelector(
    (state: any) => state.currentUser.updateCurrentUserDataError
  );
  // Setting up state to hold data for forms
  const [shelfLifeTo, setShelfLifeTo] = useState(
    certainArchiveData.shelfLifeTo
  );
  const [content, setContent] = useState(certainArchiveData.content);
  const [remark, setRemark] = useState(certainArchiveData.remark);
  const [recordNumber, setRecordNumber] = useState(
    certainArchiveData.recordNumber ? certainArchiveData.recordNumber : ""
  );
  const [recordDate, setRecordDate] = useState(
    certainArchiveData.recordDate
      ? certainArchiveData.recordDate.split("T")[0]
      : ""
  );

  const [sendingBlock, setSendingBlock] = useState("");

  // messages text states
  const [messageBasicAccountText, setMessageBasicAccoutText] = useState("");

  // status for disabled password button
  const [disabledPaswordButton, setDisabledPaswordButton] = useState(false);

  useEffect(() => {
    if (sendingBlock === "basicData") {
      handleMessageText(setMessageBasicAccoutText);
    }
  }, [updateCurrentUserData, updateCurrentUserDataStatus]);

  useEffect(() => {
    setMessageBasicAccoutText("");
  }, []);

  // Handling input change
  const handleChange = (e: any, setValue) => {
    setValue(e.target.value);
    setMessageBasicAccoutText("");
    dispatch(manuallyTrigerSuccess());
  };

  // Function for checking is object empty
  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };

  // Function for sending data to the database with certain conditions
  const sendDataToTheDatabase = (object, formData, setMessageText) => {
    if (!isEmpty(object)) {
      dispatch(updateCertainArchive(formData(), certainArchiveData.id, history));
    } else {
      setMessageText("Није промењено ниједно поље!");

      setTimeout(() => {
        setMessageText("");
      }, 3000);
    }
  };

  // Event for sending basic data to the database
  const sendBasicDataEvent = () => {
    const basicDataForm = () => {
      return {
        ...(shelfLifeTo !== certainArchiveData.shelfLifeTo && {
          shelfLifeTo: shelfLifeTo
        }),
        ...(content !== certainArchiveData.content && {
          content: content
        }),
        ...(remark !== certainArchiveData.remark && {
          remark: remark
        }),
        ...(recordNumber !== certainArchiveData.recordNumber && {
          recordNumber: recordNumber
        }),
        ...(recordDate !== certainArchiveData.recordDate && {
          recordDate: recordDate
        })
      };
    };

    setSendingBlock("basicData");

    const object: any = basicDataForm();

    sendDataToTheDatabase(object, basicDataForm, setMessageBasicAccoutText);
  };

  // function for handling error/success messages
  const handleMessageText = (setMessageText) => {
    if (updateCurrentUserDataStatus === "fail") {
      setMessageText(updateCurrentUserDataError);
      setTimeout(() => {
        setMessageText("");
      }, 3000);
    } else if (updateCurrentUserDataStatus === "success") {
      setMessageText("Успешно сте променили основне податке профила!");
      setTimeout(() => {
        setMessageText("");
      }, 3000);
    }
  };

  return (
    <div className={css.mainContainer}>
      <NavigationBar />
      <h1>Измени архиву</h1>
      <div className={css.dataContainer}>
        {/* Basic account data */}
        <div className={css.wrapperContainer}>
          <div
            className={css.container}
            onClick={() => dispatch(getCurrentUserData())}
          >
            <div>
              <h2 className={css.title}>Тренутни подаци архиве</h2>
              <hr />
              <p>
                <span>Подброј архиве: </span>
                {certainArchiveData && certainArchiveData.subnumbers
                  ? certainArchiveData.subnumbers
                  : ""}
              </p>

              <p>
                <span>Број папира архиве: </span>
                {certainArchiveData && certainArchiveData.numberOfPapers
                  ? certainArchiveData.numberOfPapers
                  : ""}
              </p>
              <p>
                <span>Документа од: </span>
                {certainArchiveData && certainArchiveData.papersFrom
                  ? certainArchiveData.papersFrom.split("T")[0]
                  : ""}
              </p>

              <p>
                <span>Документа до: </span>
                {certainArchiveData && certainArchiveData.papersTo
                  ? certainArchiveData.papersTo.split("T")[0]
                  : ""}
              </p>

              <p>
                <span>Основни број: </span>
                {certainArchiveData && certainArchiveData.baseNumber.baseNumber
                  ? certainArchiveData.baseNumber.baseNumber
                  : ""}
              </p>

              <p>
                <span>Број записника о уништењу: </span>
                {certainArchiveData && certainArchiveData.recordNumber
                  ? certainArchiveData.recordNumber
                  : ""}
              </p>

              <p>
                <span>Датум записника о уништењу: </span>
                {certainArchiveData && certainArchiveData.recordDate
                  ? certainArchiveData.recordDate.split("T")[0]
                  : ""}
              </p>
              <p>
                <span>Креирано дана: </span>
                {certainArchiveData && certainArchiveData.createdAt
                  ? certainArchiveData.createdAt.split("T")[0]
                  : ""}
              </p>

              <p>
                <span>Кратак садржај: </span>
                {certainArchiveData && certainArchiveData.content
                  ? certainArchiveData.content
                  : ""}
              </p>

              <p>
                <span>Рок чувања: </span>
                {certainArchiveData && certainArchiveData.shelfLifeTo
                  ? certainArchiveData.shelfLifeTo
                  : ""}
              </p>

              <p>
                <span>Напомена: </span>
                {certainArchiveData && certainArchiveData.remark
                  ? certainArchiveData.remark
                  : ""}
              </p>
            </div>

            <div className={css.updateDataContainerWrapper}>
              <div className={css.updateDataContainer}>
                {certainArchiveData.shelfLifeTo && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Рок чувања"
                      name="shelfLifeTo"
                      id="shelfLifeTo"
                      type="text"
                      value={shelfLifeTo}
                      handleChange={(e: any) => handleChange(e, setShelfLifeTo)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      inputType="rowInput"
                    />
                  </div>
                )}
                {certainArchiveData.content && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Кратак садржај"
                      name="content"
                      id="content"
                      type="text"
                      value={content}
                      handleChange={(e: any) => handleChange(e, setContent)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      inputType="rowInput"
                    />
                  </div>
                )}
                {certainArchiveData.content && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Напомена"
                      name="remark"
                      id="remark"
                      type="text"
                      value={remark}
                      handleChange={(e: any) => handleChange(e, setRemark)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      inputType="rowInput"
                    />
                  </div>
                )}
                {certainArchiveData.recordNumber !== "N/A" && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Број записника о уништењу"
                      name="recordNumber"
                      id="recordNumber"
                      type="text"
                      value={recordNumber}
                      handleChange={(e: any) =>
                        handleChange(e, setRecordNumber)
                      }
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      inputType="rowInput"
                    />
                  </div>
                )}
                {certainArchiveData.recordDate && (
                  <div className={css.inputFieldWrapper}>
                    <InputField
                      label="Датум записника о уништењу"
                      name="remark"
                      id="recordDate"
                      type="text"
                      value={recordDate.split("T")[0]}
                      handleChange={(e: any) => handleChange(e, setRecordDate)}
                      handleOnFocus={(e: any) => (e.target.placeholder = "")}
                      inputType="rowInput"
                    />
                  </div>
                )}

                <div className={css.buttonWrapper}>
                  <Button
                    text="Пошаљи"
                    onButtonClickHandler={sendBasicDataEvent}
                    style={{
                      borderRadius: "5rem",
                      maxHeight: "6rem",
                      border: "0.1rem solid gray"
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`${css.messageText} ${
              messageBasicAccountText ===
              "Успешно сте променили основне податке профила!"
                ? css.successMessageText
                : ""
            }`}
          >
            <p>{messageBasicAccountText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditArchive;
